"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInstagram = exports.INSTAGRAM_SELECT = void 0;
const app_1 = require("@obvio/app");
exports.INSTAGRAM_SELECT = {
    handle: true,
    posts: {
        id: true,
        caption: true,
        permalink: true,
        media_type: true,
        media_url: true,
    },
};
function useInstagram(postCount = 4) {
    return (0, app_1.useQuery)('getInstaPosts', {
        select: exports.INSTAGRAM_SELECT,
        args: { count: postCount },
    });
}
exports.useInstagram = useInstagram;
